export default __webpack_public_path__ + "static/hero_personal_back_img_2-2da928f0042eb2ab9b158f3e4b2f2ca4.png";